/**
 * Sprint 3.3 — pure presentation helpers for admin hub pages (no API calls).
 */

export function adminShortJson(obj, max = 140) {
  if (obj == null) return '—';
  try {
    const s = JSON.stringify(obj);
    if (!s) return '—';
    return s.length > max ? `${s.slice(0, max)}…` : s;
  } catch {
    return '—';
  }
}

export function adminFormatQuotasLine(quotas) {
  if (!quotas || typeof quotas !== 'object') return '—';
  const keys = ['chatMessages', 'memorandums', 'documents', 'apiCalls'];
  const parts = [];
  keys.forEach((k) => {
    if (quotas[k] != null) parts.push(`${k}=${quotas[k]}`);
  });
  return parts.length ? parts.join(', ') : adminShortJson(quotas, 120);
}

export function adminFormatAiLine(merged) {
  if (!merged || typeof merged !== 'object') return '—';
  const q = merged.quotas || {};
  const meta = merged.catalog_metadata || {};
  const bits = [];
  if (q.ai_monthly_units != null) bits.push(`ai_monthly_units=${q.ai_monthly_units}`);
  if (q.ai_units != null) bits.push(`ai_units=${q.ai_units}`);
  if (meta.ai && typeof meta.ai === 'object') bits.push(`meta.ai=${adminShortJson(meta.ai, 80)}`);
  return bits.length ? bits.join(' · ') : '—';
}

export function adminFirmModeCell(merged) {
  if (!merged || typeof merged !== 'object') return '—';
  const lim = merged.limits || {};
  const feat = merged.features || {};
  if (lim.firm_mode != null) return String(lim.firm_mode);
  if (feat.firm_mode != null) return String(feat.firm_mode);
  if (lim.firm_mode_allowed != null) return String(lim.firm_mode_allowed);
  return '—';
}

export function adminPlanTableRows(snapshot) {
  if (!snapshot || !Array.isArray(snapshot.plans)) return [];
  return snapshot.plans.map((p, idx) => {
    const row = p.row;
    const m = p.merged || {};
    const activeLabel =
      row == null ? 'catalog_fallback' : row.is_active === false ? 'inactive' : 'active';
    return {
      __rowKey: `${m.code || 'plan'}-${idx}`,
      plan_code: m.code || '—',
      audience_type: m.audience_type || '—',
      monthly_price: m.monthly_price != null && Number.isFinite(Number(m.monthly_price)) ? Number(m.monthly_price) : '—',
      annual_price: m.annual_price != null && Number.isFinite(Number(m.annual_price)) ? Number(m.annual_price) : '—',
      currency: m.currency || '—',
      is_active: activeLabel,
      limits_summary: adminFormatQuotasLine(m.quotas),
      ai_summary: adminFormatAiLine(m),
      firm_mode_hint: adminFirmModeCell(m),
      metadata_preview: adminShortJson(m.catalog_metadata, 100),
    };
  });
}

export function enforcementModeBadgeTone(mode) {
  const m = String(mode || '').toLowerCase();
  if (m === 'off') return 'neutral';
  if (m === 'shadow') return 'info';
  if (m === 'soft') return 'warn';
  if (m === 'enforce_later') return 'danger';
  return 'neutral';
}

export function readinessBoolTone(ok) {
  return ok ? 'ok' : 'warn';
}
